import React from 'react';
import { useGetArrowMethods } from './utils';
import dynamic from 'next/dynamic';
import { useListPresentationContextData } from './context/ListPresentationContext';
import { useSetScrollSections } from './hooks/useSetScrollSections';
import { useAutoRotation } from './hooks/useAutoRotation';
import { LayoutBodyWrapper, LayoutWrapper } from './components/LayoutWrapper';
import { useAdjustSubWidgetProps } from './hooks/useAdjustSubWidgetProps';

const QuickViewModal = dynamic(() =>
  import('../../QuickViewModal').then((mod) => mod.default)
);

export default function ListPresentationMain() {
  const data = useListPresentationContextData();
  const props = data.props;
  const { stopAutoRotation, startAutoRotation } = useAutoRotation();

  const { onNextArrowClick, onPrevArrowClick, carouselScrollTo } = useGetArrowMethods(
    stopAutoRotation,
    startAutoRotation
  );
  useAdjustSubWidgetProps({ stopAutoRotation, carouselScrollTo });

  useSetScrollSections();

  if (props.isVisible === false) {
    return null;
  }

  return (
    <LayoutWrapper>
      {data.elementsToMap.header.map(({ Component, props }) => (
        <Component
          key={Component.name}
          {...props}
          onNextArrowClick={onNextArrowClick}
          onPrevArrowClick={onPrevArrowClick}
        />
      ))}
      <LayoutBodyWrapper>
        {data.elementsToMap.body.map(({ Component, props }) => (
          <Component key={Component.name} {...props} />
        ))}
      </LayoutBodyWrapper>
      {data.elementsToMap.footer.map(({ Component, props }) => (
        <Component
          key={Component.name}
          {...props}
          carouselScrollTo={carouselScrollTo}
          onPrevArrowClick={() => onPrevArrowClick()}
          onNextArrowClick={() => onNextArrowClick()}
        />
      ))}
      <QuickViewModal />
    </LayoutWrapper>
  );
}
